import MatchRowTeaser from 'app/components/matchRow/teaser/MatchRowTeaser';
import React, { useCallback, useMemo } from 'react';
import splitArrayIntoChunks from 'app/components/swipeableViews/splitArrayIntoChunks';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import { MatchesView, Wrapper } from 'app/components/competitionModule/matches/commonStyles';
import { MatchRowTeaserWrapper } from 'app/components/matchRow/teaser/teaserStyles';
import SectionHeading from 'app/components/competitionModule/common/SectionHeading';
const MATCHES_PER_VIEW = 8;
export default function CompetitionModuleMatches(_ref) {
  let {
    competitionSlug,
    matches
  } = _ref;
  const viewData = useMemo(() => {
    return splitArrayIntoChunks(matches, MATCHES_PER_VIEW, true);
  }, [matches]);
  const renderView = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    return /*#__PURE__*/React.createElement(MatchesView, {
      key: "".concat(competitionSlug, "-matches-view-").concat(index)
    }, viewData[index].map((matchData, elementIndex) => {
      if (!matchData) {
        return /*#__PURE__*/React.createElement(MatchRowTeaserWrapper, {
          key: "".concat(competitionSlug, "-match-filler-").concat(elementIndex)
        });
      }
      return /*#__PURE__*/React.createElement(MatchRowTeaser, {
        key: matchData.slug,
        match: matchData
      });
    }));
  }, [competitionSlug, viewData]);
  if (!matches.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "CompetitionModuleMatches",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    "data-sentry-element": "SectionHeading",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }, "Aktuelle Spiele"), /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    stepCount: viewData.length,
    hideStepperWithoutPages: true,
    viewRender: renderView,
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }));
}